'use client'
import React from 'react'
import { useTranslations } from 'next-intl'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import { Badge } from '@/registry/default/ui/badge'

interface StoryProps {
  config?: any
}

export function Story({ config }: StoryProps) {
  const t = useTranslations('home.feature')
  return (
    <div className="">
      <div className="container flex flex-col gap-10 px-0 py-20 h-full text-foreground dark:text-background/90">
        <h6 className="text-base md:text-xl items-center text-center justify-center text-blue-600 font-medium flex w-full h-full  ">
          AI 陪伴业务增长
        </h6>
        <h2 className="text-3xl md:text-3xl font-medium  text-center w-full h-full ">
          用户故事
        </h2>
        <div className="items-start gap-8 md:justify-center w-full h-full md:grid lg:grid-cols-4 xl:grid-cols-4">
          <div className="dark:bg-card/20 rounded-md md:flex-col items-start border flex flex-col h-full">
            <Image
              alt={'design'}
              src={'/home/story-1.svg'}
              width={100}
              height={100}
              className={cn('w-full object-cover')}
            />
            <div className={'flex flex-col  space-y-4 h-full p-4'}>
              <h6 className="text-base md:text-md text-blue-600 font-medium flex w-full ">
                泉州信达
              </h6>
              <h1 className="text-xl items-start flex font-bold  w-full ">
                让 AI 与人一起工作
              </h1>
              <h2 className="text-sm items-center justify-center flex w-full  ">
                我们在全国 20+
                城市都有合作客户，几乎遍布呼叫中心涉及的所有业务。
              </h2>
              <div className={'flex gap-2'}>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  餐饮
                </Badge>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  瑜伽馆
                </Badge>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  健身馆
                </Badge>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  诊所
                </Badge>
              </div>
            </div>
          </div>
          <div className="dark:bg-card/20 rounded-md md:flex-col items-start border flex flex-col h-full">
            <Image
              alt={'design'}
              src={'/home/story-2.svg'}
              width={100}
              height={100}
              className={cn('w-full object-cover')}
            />
            <div className={'flex flex-col  space-y-4 h-full p-4'}>
              <h6 className="text-base md:text-md text-blue-600 font-medium flex w-full ">
                杭州格瓦拉
              </h6>
              <h1 className="text-xl items-start flex font-bold   w-full ">
                全自动业务闭环
              </h1>
              <h2 className="text-sm items-center justify-center flex w-full ">
                过去半年增长了 10 倍，直至今日，触达用户依然保持每个月 20%+
                的增长速度，
              </h2>
              <div className={'flex gap-2'}>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  K12教育培训
                </Badge>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  英语培训
                </Badge>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  职业教育培训
                </Badge>
              </div>
            </div>
          </div>
          <div className="dark:bg-card/20 rounded-md md:flex-col items-start border flex flex-col h-full">
            <Image
              alt={'design'}
              src={'/home/story-3.svg'}
              width={100}
              height={100}
              className={cn('w-full object-cover')}
            />
            <div className={'flex flex-col  space-y-4 h-full p-4'}>
              <h6 className="text-base md:text-md text-blue-600 font-medium flex w-full ">
                乌鲁木齐联通
              </h6>
              <h1 className="text-xl items-start flex font-bold   w-full">
                边疆多民族地区的实践
              </h1>
              <h2 className="text-sm items-center justify-center flex w-full ">
                不仅实现电话营销，还涵盖智能派单与质检，覆盖营销全流程，每日都在达成成交。
              </h2>
              <div className={'flex gap-2'}>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  K12教育培训
                </Badge>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  英语培训
                </Badge>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  职业教育培训
                </Badge>
              </div>
            </div>
          </div>
          <div className="dark:bg-card/20 rounded-md md:flex-col items-start border flex flex-col h-full">
            <Image
              alt={'design'}
              src={'/home/story-4.svg'}
              width={100}
              height={100}
              className={cn('w-full object-cover')}
            />
            <div className={'flex flex-col  space-y-4 h-full p-4'}>
              <h6 className="text-base md:text-md text-blue-600 font-medium flex w-full ">
                莆田祥兴
              </h6>
              <h1 className="text-xl items-start flex font-bold   w-full">
                复用成熟经验拓展本地业务
              </h1>
              <h2 className="text-sm items-center justify-center flex w-full ">
                针对本地服务行业，我们提供标准的 AI
                服务，帮助商家唤醒老客户，达成进店重复消费。
              </h2>
              <div className={'flex gap-2'}>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  K12教育培训
                </Badge>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  英语培训
                </Badge>
                <Badge
                  variant={'secondary'}
                  className={'bg-blue-50 text-xs text-nowrap text-blue-600'}
                >
                  职业教育培训
                </Badge>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
